import React from 'react'

import {
  // Link,
  CardMedia,
  Paper,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core'

import InputGroup from '../../../UI/Forms/InputGroup/InputGroup'
import Button from '../../../UI/Button/Button'

const AuthPanelContent = ({
  loginForm,
  inputChanged,
  formSubmitted,
  forgetClicked,
  logoSrc,
  translate
}) => {
  let formIsValid = true
  const form = Object.entries(loginForm).map(formEntry => {
    let [formKey, formAttrs] = formEntry
    formIsValid = formIsValid && formAttrs.valid

    return (
      <InputGroup
        key={formKey}
        label={formAttrs.label}
        inputType={formAttrs.elementType}
        configs={formAttrs.elementConfig}
        invalid={!formAttrs.valid}
        validations={formAttrs.validation}
        touched={formAttrs.touched}
        changed={e => inputChanged(formKey, e)}
        inputValue={formAttrs.value}
        validationError={formAttrs.error}
        variant={'outlined'}
      />
    )
  })

  return (
    <Grid container style={{ height: '100%' }} alignItems={'center'} justify={'center'}>
      <Grid item lg={4} md={6} sm={8} xs={10}>
        <Paper elevation={3}>
          <CardMedia
            component={'img'}
            src={logoSrc}
            title={'SEE KPI'}
            style={{ padding: '10%', boxSizing: 'border-box' }}
          />
          <CardContent style={{ padding: '0 10% 10% 10%' }}>
            <form onSubmit={formSubmitted}>
              {form}
              <Button
                type={'submit'}
                color={'primary'}
                disabled={!formIsValid}
                style={{ margin: '8px 0px' }}>
                {translate('login')}
              </Button>
            </form>
            {/* <Link component={'button'} onClick={forgetClicked}>
              {translate('forgetPassword')}?
            </Link> */}
            <Typography
              style={{ textAlign: 'end', padding: 6 }}
              variant='caption'
              display='block'
              gutterBottom>
              Version : {process.env.REACT_APP_VERSION || ''}
            </Typography>
          </CardContent>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default AuthPanelContent
